module.exports = "query {\n    getPhotoGallery {\n        id\n        photo\n        allow_delete\n    }\n}\n"